import React from 'react'

function PageNotFound() {
  return (
    <div className='flex justify-center content-center' style={{height: "100vh"}}>
        <h1 className='text-[#b8b8b8] text-[48px] font-bold absolute top-[295px] text-center' style={{fontFamily: "ProductSans"}}>Page Not<br/> Found</h1>
    </div>
  )
}

export default PageNotFound